import { useEffect, useRef, type ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { useStep } from '../state/useStep.js'

const INTRO_VIDEO_URL = import.meta.env.VITE_INTRO_VIDEO_URL as string | undefined

export const IntroScreen = (): ReactElement => {
  const { goto } = useStep()
  const videoRef = useRef<HTMLVideoElement>(null)

  // If no video URL is configured, auto-advance to the email screen.
  useEffect(() => {
    if (!INTRO_VIDEO_URL) goto('email')
  }, [goto])

  if (!INTRO_VIDEO_URL) return <AppShell>{null}</AppShell>

  return (
    <AppShell
      footer={<Button size="xl" onClick={() => goto('email')}>Continue</Button>}
    >
      <h1 className="text-center mb-4">Quick walkthrough</h1>
      <video
        ref={videoRef}
        src={INTRO_VIDEO_URL}
        controls
        playsInline
        className="w-full rounded-2xl bg-foreground"
      />
      <p className="text-muted-foreground text-sm text-center mt-4">
        This is what the readiness check looks like end-to-end.
      </p>
    </AppShell>
  )
}
